import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { ChartCard, ChartHeader, ChartTitleSection, ChartTitle, ChartDescription, StyledButton } from './styles';
import { ChartConfig } from './Constant';
import SalesDetailedView from '../SalesDetailedView/SalesDetailedView';
import TrendingItems from '../TrendingItems';
import Disputes from '../Disputes';

interface ChartCardWrapperProps {
  config: ChartConfig;
  onViewDetails: (tileId: string) => void;
  children: React.ReactNode;
}

export const ChartCardWrapper: React.FC<ChartCardWrapperProps> = ({ config, onViewDetails, children }) => (
  <ChartCard>
    <ChartHeader>
      <ChartTitleSection>
        <ChartTitle level={4}>{config.title}</ChartTitle>
        <ChartDescription>{config.description}</ChartDescription>
      </ChartTitleSection>
      <StyledButton
        icon={<FontAwesomeIcon icon={faEye} />}
        onClick={() => onViewDetails(config.tileId)}
        size="small"
      >
        View Details
      </StyledButton>
    </ChartHeader>
    {children}
  </ChartCard>
);

export const renderSelectedTile = (tileId: string): React.ReactElement | null => {
  const componentMap: Record<string, React.ComponentType> = {
    salesAnalytics: SalesDetailedView,
    trendingItems: TrendingItems,
    disputes: Disputes,
  };

  const Component = componentMap[tileId];
  return Component ? <Component /> : null;
};

export const hasTileComponent = (tileId: string): boolean => {
  const componentMap: Record<string, React.ComponentType> = {
    salesAnalytics: SalesDetailedView,
    trendingItems: TrendingItems,
    disputes: Disputes,
  };
  return !!componentMap[tileId];
};